import axios from 'axios';

const getEntrataStatuses = async (organizationId, programId) => {
    const response = await axios.get(
        `/organization/${organizationId}/program/${programId}/entrata-statuses`
    );
    return response.data.data;
};

export default getEntrataStatuses;
